import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';
import MainLayout from 'components/main-layout/MainLayout';
import API from 'core/Api';
import Button from 'components/Button';
import CodeForm from 'components/form/CodeForm';
import { setAuthTokensFromResponse } from 'utils/auth';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useLanguageContext } from 'store/language';
import { useModal } from 'store/modal';
import { useTwoFactorContext } from 'store/two-factor';
import ContentBG from './components/ContentBG';
import ContentEN from './components/ContentEN';

const TwoFactorAuthSettings: FC = () => {
  const { t } = useTranslation();
  const { language } = useLanguageContext();
  const { setIs2FaComplete } = useTwoFactorContext();
  const history = useHistory();
  const { showModal, hideModal } = useModal();

  /**
   * This page is only shown if the user has set
   * his 2FA (and if the 2FA flow is active?)
   */

  const confirm2FAReset = () => {
    const handleCodeSubmit = async ({ data }: { data: { code?: string } }) => {
      if (!data.code || data.code.length < 6) return;
      return API.post('auth/2fa-reset', { code: data.code })
        .then(async res => {
          const { continue_to_page: continueTo } = res.data || {};
          await setAuthTokensFromResponse(res);
          setIs2FaComplete(false);
          hideModal();
          if (continueTo === '2fa-set') return history.push('/profile/2fa-activate');
        })
        .catch(err => {
          console.log('err', err);
          showModal({
            type: 'error',
            content: err?.data?.message || t('form.invalidValue'),
          });
        });
    };

    showModal({
      type: 'form',
      heading: t('twoFA.confirmTitle'),
      content: (
        <div className="text-center">
          <p className="mb-2">{t('twoFA.confirmMsg')}</p>
          <CodeForm
            docId="2fa-reset"
            btnLabelOverride={t('twoFA.removeBtn')}
            primaryActionBtnType="danger"
            handleEmployeeSign={({ data }) => handleCodeSubmit({ data })}
          />
        </div>
      ),
    });
  };

  return (
    <MainLayout title={t('twoFA.title')}>
      <Row>
        <Col
          xs={12}
          md={8}
        >
          {language === 'bg' && <ContentBG />}
          {language === 'en' && <ContentEN />}
          <Button
            className="mt-4 reset-2fa"
            btnType="danger"
            onClick={confirm2FAReset}
          >
            {t('twoFA.restartBtn')}
          </Button>
        </Col>
      </Row>
    </MainLayout>
  );
};

export default TwoFactorAuthSettings;
